<template>
  <v-container
    class="main--text">
    <v-row
      v-if="account"
      justify="center">
      <v-col md="11">
        <v-card>
          <v-toolbar
            color="primary"
            dark>
            <v-icon medium>person</v-icon>
            <v-toolbar-title>
              教師情報
            </v-toolbar-title>
            <v-spacer/>
            <v-tooltip bottom>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  icon
                  text
                  v-on="on"
                  @click="account= !account">
                  <v-icon>details</v-icon>
                </v-btn>
              </template>
              <span>アカウント</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  icon
                  text
                  v-on="on"
                  @click="isEdit = !isEdit">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <span>編集</span>
            </v-tooltip>
          </v-toolbar>
          <TeacherProfileDisplay
            v-if="!isEdit"
            :teacher="teacher"
          />
          <TeacherProfileEdit
            v-else
            v-model="updateValue"
            @update="update"
            @searchAddress="searchAddress"
            @addNewLine="addNewLine"
            @deleteLine="deleteLine"
          />
        </v-card>
      </v-col>
    </v-row>
    <v-row
      v-else
      justify="center">
      <v-col md="11">
        <v-card>
          <v-toolbar
            color="primary"
            dark>
            <v-icon medium>person</v-icon>
            <v-toolbar-title>
              教師情報画面
            </v-toolbar-title>
            <v-spacer/>
            <v-tooltip bottom>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  icon
                  text
                  v-on="on"
                  @click="account= !account">
                  <v-icon>details</v-icon>
                </v-btn>
              </template>
              <span>アカウント</span>
            </v-tooltip>
          </v-toolbar>
            <teacher-account/>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      :value="addressError"
      width="400">
      <v-card>
        <v-container
          fluid
          grid-list-md>
          <v-row
            justify="center">
            <v-col>
              住所が見つかりませんでした。
            </v-col>
          </v-row>
          <v-row
            justify="center">
            <v-btn
            depressed
            rounded
            outlined
            color="primary"
            @click="addressError=false"
            >
              OK
            </v-btn>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import TeacherProfileDisplay from '@/components/organisms/teacher/profile/TeacherProfileDisplay.vue'
import TeacherProfileEdit from '@/components/organisms/teacher/profile/TeacherProfileEdit.vue'
import TeacherAccount from '@/components/organisms/teacher/TeacherAccount.vue'
import { TeacherRepository } from "@/repository/TeacherRepository.js"
import { firestore } from "@/repository/client/firestore.js"
import { getAddress } from "@/core/geocoding"

export default {
  name: 'TeachersProfileSetting',
  components: {
    'TeacherProfileDisplay': TeacherProfileDisplay,
    'TeacherProfileEdit': TeacherProfileEdit,
    'TeacherAccount': TeacherAccount
  },
  data() {
    return {
      teacher: this.$store.getters.teacher,
      isEdit: false,
      account: true,
      repo: null,
      updateValue: {},
      addressError: false,
    }
  },
  methods: {
    async update() {

      this.teacher.name = this.updateValue.name
      this.teacher.sex = this.updateValue.sex
      this.teacher.phone = this.updateValue.phone
      this.teacher.address = this.updateValue.address
      this.teacher.birthday = this.updateValue.birthday
      this.teacher.university = this.updateValue.university
      this.teacher.inUniversity = this.updateValue.inUniversity
      this.teacher.availableSchedules = this.updateValue.availableSchedules
      this.teacher.nearestStation = this.updateValue.nearestStation
      this.teacher.expectedWage = this.updateValue.expectedWage
      this.teacher.selfIntroduction = this.updateValue.selfIntroduction

      this.teacher = await this.repo.update(this.teacher)
      this.$store.commit('loginAsTeacher', this.teacher)
      this.isEdit = false
    },
    async searchAddress() {
      try {
        const result = await getAddress(this.updateValue.address.postalCode)
        this.updateValue.address.prefecture =  result.prefecture
        this.updateValue.address.municipality = result.municipality
      } catch(e) {
        // console.log(e)
        this.addressError = true
      }
    },
    addNewLine(schedule) {
      // console.log("schedule:" + this.updateValue.availableSchedules)
      this.updateValue.availableSchedules.addNew()
    },
    deleteLine(schedule) {
      if (this.updateValue.availableSchedules.length() > 1) {
        this.updateValue.availableSchedules.remove(schedule)
      }
    },
  },
  created: function() {
    this.updateValue = {...this.teacher}
    this.repo = new TeacherRepository(firestore)
  }
}
</script>

<style scoped>
</style>


</style>